import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import rootReducer, { initialState } from '../reducers';

const loggerMiddleware = createLogger({
  predicate: () => false // Disable logging
});
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose();

export const configureStore = () => {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware))
  );

  return store;
};

export default configureStore;
